import { PayloadAction } from "@reduxjs/toolkit";
import { IInitialState } from "./types";

export const reducers = {
  setOnboardingTimeout: (
    state: IInitialState,
    action: PayloadAction<string | null>,
  ) => {
    state.onboardingTimeout = action.payload;
  },
};
